
define('text!templates/widgets/dataGridCells/textCell.html',[],function () { return '<span data-bind="text: $data"></span>';});

